module.exports = __webpack_public_path__ + "img/运动健康之家1.f759f31d.jpg";